// Helper functions for form type conversions

export const convertToString = (
  value: string | boolean | null | undefined
): string => {
  if (value === null || value === undefined) return "";
  return value.toString();
};

export const convertToBoolean = (value: string): boolean | null => {
  if (value === "true") return true;
  if (value === "false") return false;
  if (value === "null") return null;
  return null;
};

export const safeStringValue = (value: string | null | undefined): string => {
  return value ?? "";
};

// Convert Option arrays to string-only values for shadcn components
export const convertOptionsToString = (
  options: Array<{ label: string; value: string | boolean }>
) => {
  return options.map((opt) => ({
    label: opt.label,
    value: opt.value.toString(),
  }));
};

// Wrapper for Input field props to handle null values
export const safeInputProps = (field: any) => ({
  ...field,
  value: safeStringValue(field.value),
});

// Wrapper for Select field props to handle null values
export const safeSelectProps = (field: any) => ({
  ...field,
  value: safeStringValue(field.value),
});
